import React from 'react';
import { useLanguage } from '../../context/language/LanguageContext';
import { administrationData } from '../../utils/administrationData';
import './Guardians.css';

const Guardians = () => {
    const { language } = useLanguage();
    const data = administrationData[language];

    return (
        <div className="guardians-page">
            <div className="guardians-hero-section">
                <div className="guardians-hero-content">
                    <div className="guardians-hero-text">
                        <h1>{data.title}</h1>
                        <p className="guardians-hero-description">{data.subtitle}</p>
                    </div>
                    <div className="guardians-hero-decoration">
                        <div className="guardians-vertical-line"></div>
                        <div className="guardians-circle-container">
                            <div className="guardians-circle"></div>
                            <div className="guardians-circle"></div>
                            <div className="guardians-circle"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="guardians-content-container">
                <section className="guardians-intro-section">
                    <h2>{data.introduction.title}</h2>
                    <p>{data.introduction.content}</p>
                </section>

                <div className="guardians-sections-grid">
                    {data.sections.map((section, index) => (
                        <section key={index} className="guardians-content-section">
                            <h3>{section.title}</h3>
                            <p>{section.content}</p>

                            {section.note && (
                                <div className="guardians-note">
                                    <i className="fas fa-info-circle"></i>
                                    <p>{section.note}</p>
                                </div>
                            )}

                            {section.responsibilities && (
                                <ul className="guardians-responsibilities-list">
                                    {section.responsibilities.map((item, idx) => (
                                        <li key={idx}>
                                            <i className="fas fa-check"></i>
                                            <span>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            )}

                            {section.schedule && (
                                <ul className="guardians-schedule-list">
                                    {section.schedule.map((item, idx) => (
                                        <li key={idx}>
                                            <i className="fas fa-clock"></i>
                                            <span>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </section>
                    ))}
                </div>

                <section className="guardians-conclusion-section">
                    <h3>{data.conclusion.title}</h3>
                    <p className="guardians-conclusion-text">{data.conclusion.content}</p>
                </section>
            </div>
        </div>
    );
};

export default Guardians;